/*
 * Authors: mariushirjanu
 * Created: 24/11/2023
 */
import { Inject, Injectable } from '@angular/core';
import { TransporterToken } from './transporters/transporters-config';
import { TransporterBaseService } from './transporters/transporter-base.service';
import { ILogPayload, LogLevel, LogType } from './remote-logger-data.service';

const MINIMUM_LEVEL_TO_LOG:LogLevel = LogLevel.ERROR;

@Injectable()
export class LoggerService {
  constructor(
    @Inject(TransporterToken) private transporters:TransporterBaseService[],
    @Inject(Window) private window:Window
  ) {
    /***/
  }

  public error(error:LogType):void {
    this.logWith(LogLevel.ERROR, error);
  }

  public warn(message:string):void {
    this.logWith(LogLevel.WARN, message);
  }

  public debug(message:string):void {
    this.logWith(LogLevel.DEBUG, message);
  }

  public info(message:string):void {
    this.logWith(LogLevel.INFO, message);
  }

  private logWith(logLevel:LogLevel, log:LogType) {
    if (this.isEventLevelLessThanLogLevel(logLevel, log)) {
      const payload:ILogPayload = {
        message: log,
        level: logLevel,
        timestamp: new Date().getTime(),
        date: new Date(),
        clientUrl: this.window.location.href
      };

      if(log instanceof Error){
        payload.message = log.message;
        payload.stack = log.stack;
      }

      // send captured payload to each transporter to be written
      for (const transport of this.transporters) {
        this.execute(transport, payload, logLevel);
      }
    }
  }

  private execute(transport:TransporterBaseService, logData:ILogPayload, level:LogLevel) {
    // send to the event queue to minimize the stack processing for the application
    this.window.queueMicrotask(() => transport.write(logData, level));
  }

  private isEventLevelLessThanLogLevel(logLevel:LogLevel, payload:LogType):boolean {
    if (!payload) {
      return false;
    }
    switch (MINIMUM_LEVEL_TO_LOG) {
      case LogLevel.DEBUG: return true;
      case LogLevel.INFO: return [ LogLevel.INFO, LogLevel.WARN, LogLevel.ERROR ].indexOf(logLevel) >= 0;
      case LogLevel.WARN: return [ LogLevel.WARN, LogLevel.ERROR ].indexOf(logLevel) >= 0;
      case LogLevel.ERROR: return logLevel === LogLevel.ERROR;
    }
  }
}